import { create } from 'zustand'
import { setAccessToken } from '@/api/client'
import type { CurrentUser } from '@/api/types'

interface AuthState {
  user: CurrentUser | null
  status: 'unknown' | 'authenticated' | 'anonymous'
  setSession: (token: string, user: CurrentUser) => void
  setUser: (user: CurrentUser) => void
  clear: () => void
  isAdmin: () => boolean
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  status: 'unknown',

  setSession: (token, user) => {
    setAccessToken(token)
    set({ user, status: 'authenticated' })
  },

  setUser: (user) => set({ user }),

  clear: () => {
    setAccessToken(null)
    set({ user: null, status: 'anonymous' })
  },

  isAdmin: () => get().user?.roles.includes('ROLE_ADMIN') ?? false,
}))
